/**
 * Контракт між apps/api і apps/web. Єдине джерело правди для форм даних —
 * усе інше виводиться звідси через z.infer / Pick / ComponentProps, а не
 * оголошується повторно (§5.4).
 *
 * Пакет живе окремо саме тому, що інакше обидва застосунки описали б ті самі
 * поля власними інтерфейсами — і розійшлися б мовчки, без помилки збірки.
 * Бекенд зобовʼязаний віддавати рівно ці форми, фронт — рівно їх приймати.
 *
 * Модель навмисно НАША, а не форма провайдера: Copart та IAAI нормалізуються
 * в один вигляд, і жоден зовнішній фід не протікає в UI (§5.6). Сира відповідь
 * провайдера за межі apps/api не виходить взагалі.
 */
/**
 * Порти відправлення США, через які возить клієнт (рішення 2026-10-22): New York,
 * Savannah, Houston і Long Beach — зі сходу на захід, як колонки його прайсу.
 * Коди — як у провайдера (`location.send_from`); LA — це Long Beach. Norfolk,
 * Miami, Chicago і Seattle прибрані: у старих ставках і інвойсах вони лишились
 * рядком, назовні такий порт іде як null.
 */
export const DEPARTURE_PORTS = ['NY', 'Savannah', 'Houston', 'LA'];
/* ── Каталог: фільтри ─────────────────────────────────────────────────────
   Значення, за якими провайдер фільтрує САМ (OpenAPI-схема Apibara, знято
   2026-09-19). Каталог шле рівно їх, бекенд приймає рівно їх — спільний
   перелік не дає двом застосункам розійтись. Невідоме значення провайдер
   відхиляє 422, а невідому назву параметра мовчки ігнорує, тож вгадувати
   тут не можна: лише звірятись зі схемою. */
/**
 * Пошкодження, за якими провайдер уміє фільтрувати. У даних їх близько
 * двадцяти, а в фільтрі — лише ці дев'ять: найчастішого «Front end» тут
 * немає, і відфільтрувати за ним на боці провайдера неможливо.
 */
export const FILTERABLE_DAMAGES = [
    'Fire', 'Hail', 'Theft', 'Water', 'Chemical', 'Rollover', 'Mechanical', 'Vandalized', 'Repossession',
];
export const FUEL_TYPES = ['Gasoline', 'Diesel', 'Electric', 'Flexible', 'Hybrid', 'All others'];
export const DRIVE_TYPES = ['AWD', 'FWD', 'RWD'];
export const RUN_CONDITIONS = ['RUNS AND DRIVES', 'ENGINE START PROGRAM', 'STATIONARY', 'NO INFORMATION'];
export const VEHICLE_COLORS = [
    'Black', 'White', 'Silver', 'Gray', 'Blue', 'Red', 'Green', 'Yellow', 'Orange', 'Beige', 'Brown', 'Burgundy', 'Gold',
    'Other',
];
/**
 * Редакція Terms & Conditions і Privacy Policy, яку показує форма реєстрації.
 * Форма шле її разом зі згодою, бекенд приймає лише чинну й записує в
 * `user.termsVersion` з часом згоди. Нова редакція — нове значення тут.
 *
 * Поки юридичних текстів немає, редакція позначена як чернетка: тексти в
 * модалках — заповнювач (рішення 2026-09-29).
 */
export const TERMS_VERSION = '2026-09-draft';
/**
 * Статуси, у яких ставка тримає депозит і блокує нову ставку на той самий лот.
 *
 * Джерело істини одне на всіх: бекенд перевіряє цим переліком подачу ставки,
 * фронт цим же переліком вирішує, чи показувати на картці лота форму, чи вже
 * подану ставку. Дві копії розійшлися б мовчки, без помилки збірки.
 */
export const BID_STATUSES_HOLDING_DEPOSIT = [
    'PENDING',
    'ACTIVE',
    'HIGHEST_BIDDER',
    'OUTBID',
    'WON',
];
/** Скільки лотів можна тримати у Watchlist: більше — це вже не список, а каталог. */
export const WATCHLIST_LIMIT = 200;
/** Межі суми одного поповнення, цілі долари. Перевіряє бекенд; форма — лише для підказки. */
export const TOP_UP_MIN_USD = 100;
export const TOP_UP_MAX_USD = 500_000;
